import DataTable from "react-data-table-component";
import React from "react";
import { Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  setBalanceDetailsLimit,
  setBalanceDetailsPage,
} from "../../../../redux/actions/reports/reportsAction";

import { conditionalRowStyles, currency } from "./utils";
import SpinnerComponent from "../../../../components/spinner/spinner";
import moment from "moment";

export const AccountingDetails = ({ category }) => {
  const { accountingDetails } = useSelector((state) => state.report);
  const {commonLoading}=useSelector((state)=>state.common)
  const dispatch = useDispatch();

  const columns = [
    {
      name: "subscription Id",
      selector: (row) => row?.id || "MockData",
      sortable: true,
    },
    {
      name: "Purchase Date",
      selector: (row) =>
        moment(row?.createdAt).format("YYYY-MM-DD hh:mm:ss") || "MockData",
      sortable: true,
    },
    {
      name: "Subscrption Status",
      selector: (row) => {
        let status = "";
        if (row?.isVoided != "0") status = row?.status;
        if (row?.isAfterReturn) status = "Returned";
        if (row?.isUpgraded) status = "Upgraded";
        if (row?.upgradedFromPackage) status = "Upgraded To";
        return status;
      },
      sortable: true,
    },
    {
      name: "Start Date",
      selector: (row) =>
        moment(row?.startDate).format("YYYY-MM-DD hh:mm:ss") || "MockData",
      sortable: true,
    },
    {
      name: "End Date",
      selector: (row) =>
        moment(row?.endDate).format("YYYY-MM-DD hh:mm:ss") || "MockData",
      sortable: true,
    },
    {
      name: "Member Name",
      selector: (row) =>
        row.memberName ? (
          <span
            style={{
              color: row.isDeleted ? "red" : "inherit",
              fontWeight: row.isDeleted ? "bold" : "normal",
            }}
            title={row.isDeleted ? "Deleted Member" : ""}
          >
            {row.memberName}
          </span>
        ) : (
          "Not Available"
        ),
      sortable: true,
    },
    {
      name: "Package Name",
      selector: (row) => row?.packageName || "Not available",
      sortable: true,
    },

    {
      name: `Price`,
      selector: (row) =>
        `${(row?.paymentType == "Complimentary"
          ? row?.packagePrice?.toLocaleString()
          : row?.purchasedPackagePrice * (row?.quantity || 1)
        )?.toLocaleString()} ${currency || "JOD"}` || 0,
      sortable: true,
    },

    {
      name: `Discount Amount`,
      selector: (row) => {
        const discountedAmount = parseFloat(
          (
            ((row?.paymentType == "Complimentary" ? 100 : row?.discount) *
              (row?.paymentType == "Complimentary"
                ? row?.packagePrice?.toLocaleString()
                : row?.purchasedPackagePrice) *
              (row?.quantity || 1)) /
            100
          ).toFixed(2)
        );
        return `${discountedAmount} ${currency || "JOD"}`;
      },
      sortable: true,
    },
    {
      name: `Subtotal`,
      selector: (row) => {
        const discountedAmount =
          (row?.purchasedPackagePrice * (row?.quantity || 1) * row?.discount) /
          100;
        return `${(
          row?.purchasedPackagePrice * (row?.quantity || 1) -
          discountedAmount
        )?.toLocaleString()} ${currency || "JOD"}`;
      },

      sortable: true,
    },

    {
      name: "Received Amount",
      selector: (row) =>
        row.isAfterReturn || row.isVoided
          ? 0
          : row?.recievedAmount?.toLocaleString() || "0",
      sortable: true,
    },
    {
      name: "Remaining Amount",
      selector: (row) => row?.remainingAmount?.toLocaleString() || "0",
      sortable: true,
    },
    {
      name: "Return Amount",
      selector: (row) => {
        if (row?.isAfterReturn) row.returnAmount = Math.abs(row?.returnAmount);
        return (
          (
            row?.returnAmount + row?.returnedAmountFromUpgraded
          )?.toLocaleString() || "0"
        );
      },
      sortable: true,
    },
    {
      name: "Voided Amount",
      selector: (row) => {
        if (row.isVoided) return (row.recievedAmount * -1)?.toLocaleString();
      },
      sortable: true,
    },
    {
      name: "Net Amount",
      selector: (row) => {
        if (row?.isAfterReturn) {
          row.returnAmount = Math.abs(row?.returnAmount);
          row.recievedAmount = 0;
        }
        if (row.isVoided ) {
          if(row?.voidedOnSameDay=='sameDay')return 0
          else return row?.recievedAmount
        }

        return (
          row.recievedAmount -
          row?.returnAmount 
        )?.toLocaleString();
      },

      sortable: true,
    },
    {
      name: "Payment Type",
      selector: (row) => {
        let type;
        switch (row?.paymentType) {
          case "CC":
            type = "Visa";

            break;
          case "L":
            type = "Cash";

            break;
          case "BA":
            type = "Bank";

            break;
          case "CO":
            type = "Complimantry";

            break;
          case "SP":
            type = "Split";

            break;
          default:
            type = row?.paymentType;

            break;
        }
        return type;
      },
      sortable: true,
    },
    {
      name: "Upgraded From Package Name",
      selector: (row) => row?.upgradedFromPackage || "",
      sortable: true,
    },
    {
      name: "Upgraded To Package Name",
      selector: (row) => row?.upgradedToPackage || "",
      sortable: true,
    },
    {
      name: "Transfered From Member",
      selector: (row) => row?.transferedFromMemberName || "",
      sortable: true,
    },
    {
      name: "Transfered To Member",
      selector: (row) => row?.transferedMemberName || "",
      sortable: true,
    },
    // {
    //   name: "Date of created Upgraded subscrption",
    //   selector: (row) => row?.createdAtFromUpgraded || "",
    //   sortable: true,
    // },

    {
      name: "Assigned Trainer",
      selector: (row) => row?.assignedTrainer || "----------",
      sortable: true,
    },
    {
      name: "Created By",
      selector: (row) => row?.createdBy || "----------",
      sortable: true,
    },
    {
      name: "Note",
      selector: (row) => {
        let note =row.note
        if(!note.trim()){
          if(row.isTransfered){
            note=`Transfered To ${row?.transferedMemberName} at ${moment(row?.transferedDate).format("DD/MM/YYYY")}` 
          }
          else if(row?.transferedFrom){
            note=`Transfered from ${row?.transferedFromMemberName}}` 
          }
          else note="N/A"
        }
        return note
      },
      sortable: true,
    },
  ];

  const jfColumns = [
    {
      name: "subscription Id",
      selector: (row) => row?.id || "MockData",
      sortable: true,
    },
    {
      name: "Joining Date",
      selector: (row) =>
        moment(row?.createdAt).format("YYYY-MM-DD hh:mm:ss") || "MockData",
      sortable: true,
    },

    {
      name: "Member Name",
      selector: (row) =>
        row.name ? (
          <span
            style={{
              color: row.isDeleted ? "red" : "inherit",
              fontWeight: row.isDeleted ? "bold" : "normal",
            }}
            title={row.isDeleted ? "Deleted Member" : ""}
          >
            {row.name}
          </span>
        ) : (
          "Not Available"
        ),
      sortable: true,
    },

    {
      name: "Payment Type",
      selector: (row) => {
        let type;
        switch (row?.paymentType) {
          case "CC":
            type = "Visa";

            break;
          case "L":
            type = "Cash";

            break;
          case "BA":
            type = "Bank";

            break;
          case "CO":
            type = "Complimantry";

            break;
          case "SP":
            type = "Split";

            break;
          default:
            type = row?.paymentType;
            break;
        }
        return type;
      },
      sortable: true,
    },
    {
      name: "Received Amount",
      selector: (row) =>
       (row.isVoided && row?.voidedOnSameDay == "sameDay" ? 0 : row?.recievedAmount?.toLocaleString() || 0),
      sortable: true,
    },
  ];

  const retailColumns = [
    {
      name: "subscription Id",
      selector: (row) => row?.id || "MockData",
      sortable: true,
    },
    {
      name: "Purchase Date",
      selector: (row) =>
        moment(parseInt(row?.createdAt)).format("YYYY-MM-DD hh:mm:ss") ||
        "MockData",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (row?.isAfterReturn == 1 ? "Returned" : ""),
      sortable: true,
    },
    {
      name: "Member Name",
      selector: (row) =>
        row.memberName ? (
          <span
            style={{
              color: row.isDeleted ? "red" : "inherit",
              fontWeight: row.isDeleted ? "bold" : "normal",
            }}
            title={row.isDeleted ? "Deleted Member" : ""}
          >
            {row.memberName}
          </span>
        ) : (
          "Not Available"
        ),
      sortable: true,
    },
    {
      name: "Product Name",
      selector: (row) => row?.productName || "Not available",
      sortable: true,
    },
    {
      name: "Product Category",
      selector: (row) => row?.category || "Not available",
      sortable: true,
    },
    {
      name: `Price`,
      selector: (row) => row?.productPrice?.toLocaleString(),
      sortable: true,
    },
        {
      name: `Cost`,
      selector: (row) => parseInt(row?.cost)?.toLocaleString()|| 1,
      sortable: true,
    },
    {
      name: `Quantity`,
      selector: (row) => row?.quantity || 1,
      sortable: true,
    },
    {
      name: `Discount Amount`,
      selector: (row) => {
        const discountedAmount = parseFloat(
          (
            ((row?.paymentType == "Complimentary" ? 100 : row?.discount) *
              (row?.paymentType == "Complimentary"
                ? row?.productPrice
                : row?.purchasedPrice) *
              (row?.quantity || 1)) /
            100
          ).toFixed(2)
        );
        return `${discountedAmount} ${currency || "JOD"}`;
      },
      sortable: true,
    },
    {
      name: `Subtotal`,
      selector: (row) => {
        const discountedAmount =
          (row?.purchasedPrice * (row?.quantity || 1) * row?.discount) / 100;
        return `${(
          row?.purchasedPrice * (row?.quantity || 1) -
          discountedAmount
        )?.toLocaleString()} ${currency || "JOD"}`;
      },

      sortable: true,
    },
    {
      name: "Payment Type",
      selector: (row) => {
        let type;
        switch (row?.paymentType) {
          case "CC":
            type = "Visa";

            break;
          case "L":
            type = "Cash";

            break;
          case "BA":
            type = "Bank";

            break;
          case "CO":
            type = "Complimantry";

            break;
          case "SP":
            type = "Split";

            break;
          default:
            type = row?.paymentType;

            break;
        }
        return type;
      },
      sortable: true,
    },
    {
      name: "Received Amount",
      selector: (row) => {
        if (row.isAfterReturn) {
          return 0;
        } else {
          return row?.recievedAmount?.toLocaleString() || "0";
        }
      },
      sortable: true,
    },
    {
      name: "Returned Amount",
      selector: (row) => {
        if (row?.isAfterReturn) return Math.abs(row.recievedAmount)?.toLocaleString();
        else return 0;
      },

      sortable: true,
    },
    {
      name: "Net Amount",
      selector: (row) => {
        return row.recievedAmount?.toLocaleString();
      },
      sortable: true,
    },
    {
      name: "Remaining Amount",
      selector: (row) => row?.remainingAmount?.toLocaleString() || "0",
      sortable: true,
    },
    {
      name: "Assigned To",
      selector: (row) => row?.assignedSeller || "---",
      sortable: true,
    },
    {
      name: "Created  By",
      selector: (row) => row?.createdBy || "---",
      sortable: true,
    },
    {
      name: "Note",
      selector: (row) => row?.note || "---",
      sortable: true,
    },
  ];

  if (commonLoading) {
    return (
      <div
        style={{ height: "200px" }}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <SpinnerComponent />
        <h3>Please wait</h3>
      </div>
    );
  }
  return (
    <Row>
      <Col xs={12} className="mt-4">
        {accountingDetails?.data && (
          <DataTable
            responsive
            className="dark-blue-table"
            columns={
              category == "retail"
                ? retailColumns
                : category == "jf"
                ? jfColumns
                : columns
            }
            data={accountingDetails?.data}
            pagination
            paginationServer
            paginationTotalRows={accountingDetails?.totalCount}
            conditionalRowStyles={conditionalRowStyles}
            onChangeRowsPerPage={(newLimit) =>
              dispatch(setBalanceDetailsLimit(newLimit))
            }
            onChangePage={(newPage) => dispatch(setBalanceDetailsPage(newPage))}
          />
        )}
      </Col>
    </Row>
  );
};
